<script lang="ts">
  import type { StorageReference } from "firebase/storage"
  import { listAll, getDownloadURL } from "firebase/storage"
  import { createEventDispatcher, onMount } from "svelte"

  export let target: StorageReference
  export let position = 0

  const dispatch = createEventDispatcher()

  type Item = {
    ref: StorageReference
    getURL: () => Promise<string>
    index: number
  }
  let items: Item[] = []
  $: shows = items.slice(position, position + 3)

  onMount(async () => {
    const result = (await listAll(target)).items
      .filter((x) => x.name.endsWith(".jpg") && !x.name.startsWith("thumbnail."))
      .sort((a, b) => {
        const x = parseInt(a.name.slice(0, a.name.indexOf(".")))
        const y = parseInt(b.name.slice(0, b.name.indexOf(".")))
        if (x < y) return -1
        if (x > y) return 1
        return 0
      })
      .map((x, idx) => {
        return {
          ref: x,
          getURL: getCachedDownloadURL(x),
          index: idx,
        }
      })
    const dummy = { ref: null, getURL: null, index: -1 }
    items = [dummy, ...result, dummy]
  })

  export async function getFileSharingOptions(): Promise<any> {
    const url = new URL(await items[position + 1].getURL())
    url.search = ""
    return {
      url: url.toString(),
      page: position + 1,
    }
  }

  function getCachedDownloadURL(ref: StorageReference): () => Promise<string> {
    let cache = null
    return async (): Promise<string> => {
      if (cache) {
        return cache
      }
      cache = await getDownloadURL(ref)
      return cache
    }
  }

  function onClickItem(ev: MouseEvent) {
    const idx = (<HTMLElement>ev.currentTarget).dataset.idx
    if (idx == "0") {
      position -= 1
    } else if (idx == "2") {
      position += 1
    }
    dispatch("change", position + 1)
  }
</script>

<div class="pdf">
  {#each shows as item, idx (item.index)}
    <!-- svelte-ignore a11y-click-events-have-key-events -->
    <div
      class="container"
      on:click={onClickItem}
      data-idx={idx}
      data-clickable={item.index != position && item.index != -1 ? "true" : "false"}
    >
      {#if item.getURL}
        {#await item.getURL() then url}
          <img src={url} alt={item.ref.name} decoding="async" />
        {/await}
      {/if}
    </div>
  {/each}
  <p>{position + 1} / {items.length - 2}</p>
</div>

<style>
  .pdf {
    display: grid;
    width: 100%;
    height: 100%;
    grid-gap: 1em;
    grid-template-areas:
      "main main"
      "prev next"
      "page page";
    grid-template-columns: 1fr 1fr;
    grid-template-rows: 2.5fr 1fr 1.5em;
  }
  .pdf > div:nth-child(1) {
    grid-area: prev;
  }
  .pdf > div:nth-child(2) {
    grid-area: main;
  }
  .pdf > div:nth-child(3) {
    grid-area: next;
  }
  .pdf > p {
    grid-area: page;
    justify-self: center;
    align-self: center;
  }
  .container {
    width: 100%;
    height: 100%;
    overflow: hidden;
  }
  .container[data-clickable="true"] {
    cursor: pointer;
  }
  .container[data-clickable="false"] {
    pointer-events: none;
  }
  img {
    width: 100%;
    max-height: 100%;
    object-fit: contain;
  }
</style>
